export enum Width {
  fluid = 'fluid',
  default = 'default'
}
